<template>
  <div>
    <v-card elevation="0" class="w-100 d-flex flex-wrap">
      <v-card v-for="(key, index) in ['bradesco', 'inter', 'itau', 'santander']" :key="index"
        class="pa-3 mx-2 mb-2 status-card w-100">
        <v-skeleton-loader color="transparent" elevation="0" v-if="loading"
          type="list-item, list-item-two-line, list-item-two-line"
          :style="'border-radius: 0px; background: transparent'"></v-skeleton-loader>

        <template v-else>
          <div class="d-flex justify-space-between align-center flex-wrap mb-3">
            <div>
              <span>{{ orderSummary[key].name }}</span>
            </div>
            <div>
              <span class=" font-weight-medium f-size-14 mr-2">Proposta nro.</span>
              <v-chip label color="#1e2029" class=" length-avatar" size="x-small">{{ orderSummary[key].id || "-"
                }}</v-chip>
            </div>
          </div>

          <div class="mt-1">
            <span class="d-block  f-weight-medium-bold f-size-14 mb-1">Condições de aprovação</span>
            <span class="d-block f-size-12">Valor aprovado:
              {{
                orderSummary[key].value
                  ? formatCurrencyBRL(orderSummary[key].value)
                  : "R$ -,--"
              }}</span>
            <span class="d-block f-size-12">CET: {{ orderSummary[key].cet || "-%" }}%</span>
            <span class="d-block f-size-12">TX de: {{ orderSummary[key].interest_rate || "-%" }}%</span>
          </div>

          <div class="mt-1">
            <span class="d-block font-italic f-size-10">atualizado
              {{
                orderSummary[key].status_date
                  ? moment(orderSummary[key].status_date).fromNow()
                  : "-"
              }}
            </span>
          </div>

          <div class="mt-1">
            <span class=" f-weight-medium-bold f-size-14 mr-2">Status</span>
            <v-chip label :color="orderSummary[key].status_category_color || '#1e2029'" class="" size="x-small">{{
              orderSummary[key].status_category_label || "Indisponível"
            }}</v-chip>
          </div>

          <div class="mt-1">
            <span class="d-block f-size-12">{{
              orderSummary[key].status_translation_description_partner || "-"
              }}</span>
            <span class="d-block f-size-12">{{
              orderSummary[key].status_translation_description ||
              "Não há status integrado para este parceiro."
            }}</span>
          </div>
        </template>
      </v-card>
    </v-card>
  </div>
</template>

<script>
import axios from 'axios'
import moment from "moment";
import AppExtensionsSDK from '@pipedrive/app-extensions-sdk';
import { onMounted, ref, getCurrentInstance } from "vue";
import { usePipedriveStore } from '../composables/use-pipedrive-store';
import { pipedriveApi } from '../services/pipedriveApi';
import { formatCurrencyBRL } from "../helpers/formatCurrency";

moment.locale("pt-br");

export default {
  setup() {
    const app = getCurrentInstance();

    const { loadRealEstateOrderSummary } = usePipedriveStore(app.root);

    const iframeReady = ref(false)

    const initializeSdk = async () => {
      try {
        // SDK detects identifier from URL and uses default custom UI size
        const app = new AppExtensionsSDK();

        if (!app) {
          throw new Error('ExtensionSDK não está disponível ou não contém o método initialize')
        }

        await app.initialize({
          clientId: process.env.VUE_APP_PIPEDRIVE_CLIENT_ID, // Certifique-se de configurar no .env
          size: {
            height: 700
          }
        })

        iframeReady.value = true
      } catch (err) {
        console.error('Erro ao inicializar SDK:', err)
      }
    }

    const orderSummary = ref({
      bradesco: {
        name: "Bradesco"
      },
      inter: {
        name: "Inter"
      },
      itau: {
        name: "Itaú"
      },
      santander: {
        name: "Santander"
      }
    });

    const loading = ref(false);
    const orderIdKey = ref(null);
    const orderId = ref(null);

    const findOrderIDFieldId = async (token, refreshToken) => {
      try {
        const fields = await pipedriveApi.getCustomFields(token)
        const orderIDField = fields.find(field => field.name.toLowerCase() === 'order_id')
        if (orderIDField) {
          orderIdKey.value = orderIDField.key
          return orderIDField.key
        }
        throw new Error('Campo orderID não encontrado')
      } catch (err) {
        if (err.response.status == 401) {
          const response = await pipedriveApi.refreshToken(refreshToken);
          await findOrderIDFieldId(response.data.data.access_token)
        }
        throw new Error('Erro ao buscar custom fields')
      }
    }

    const dealId = ref(null);
    const theme = ref("light");

    const getOrderIDValue = async (token) => {
      try {
        window.location.search.split("&").forEach((item) => {
          if (item.includes("selectedIds") && item.split("=").length > 0) {
            return dealId.value = item.split("=")[1]
          }

          if (item.includes("theme") && item.split("=").length > 0) {
            return theme.value = item.split("=")[1]
          }
        })
        const fieldId = orderIdKey.value;
        const deal = await pipedriveApi.getDealCustomField(dealId.value, token)
        if (deal && deal[fieldId]) {
          orderId.value = deal[fieldId];
        } else {
          throw new Error('OrderID não encontrado para este deal')
        }
      } catch (err) {
        throw err
      }
    }

    const getOrderSummary = async () => {
      try {
        const summary = await loadRealEstateOrderSummary(orderId.value);
        Object.keys(orderSummary.value).forEach(key => {
          orderSummary.value[key] = {
            ...summary[key],
            ...orderSummary.value[key],
            id: summary[`${key}_partner_id`] || ""
          };
        });
        orderSummary.value = {
          ...summary,
          ...orderSummary.value
        };
      } catch (err) {
        console.log(err)
      }
    }

    onMounted(async () => {
      try {
        loading.value = true;
        await initializeSdk();

        const response = await axios.post('https://br2ht4cf5a.execute-api.sa-east-1.amazonaws.com/dev/pipedrive/auth');
        const token = response?.data?.data?.access_token;
        const refreshToken = response?.data?.data?.refresh_token;
        
        await findOrderIDFieldId(token, refreshToken);
        await getOrderIDValue(token);
        await getOrderSummary();
        loading.value = false;
      } catch (error) {
        console.log(error)
      }
    });

    return {
      iframeReady,
      orderSummary,
      loading,
      formatCurrencyBRL,
      moment,
      theme
    };
  }
};
</script>

<style scoped>
.status-card {
  border-radius: 4px !important;
}

.length-avatar {
  border: 1px solid #ececed !important;
}


.partner-logo svg {
  width: 70px !important;
  height: 40px;
}
</style>

<!-- <style>
::-webkit-scrollbar {
  width: 8px !important;
}

::-webkit-scrollbar-track {
  background: #2d2d2d !important;
  border-radius: 10px;
}

::-webkit-scrollbar-thumb {
  background: #6b6b6b !important;
  border-radius: 10px;
}

::-webkit-scrollbar-thumb:hover {
  background: #6b6b6b !important;
}
</style>
 -->